import { thumbHashToDataURL } from 'thumbhash'

export const getDataURL = (
  thumbhash: string | null | undefined
): string | undefined => {
  if (!thumbhash) {
    return undefined
  }
  const bytes = Uint8Array.from(atob(thumbhash), (c) => c.charCodeAt(0))
  return thumbHashToDataURL(bytes)
}
